import React from 'react';
import { Grid, InputLabel } from '@material-ui/core';
import BaseRadioGroup from '@material-ui/core/RadioGroup';
import { useTranslation } from 'react-i18next';
import { useField } from 'formik';

import { SWITCH_COLOR } from '../../enum/formProps';
import './RadioGroup.scss';

interface RadioGroupProps {
  label: string;
  name: string;
  color?: SWITCH_COLOR;
}

const RadioGroup: React.FC<RadioGroupProps> = (props) => {
  const { t } = useTranslation();
  const [field, meta] = useField(props);

  return (
    <Grid container spacing={0} className="RadioGroup-Container">
      <Grid item xs={4} md={3} lg={2} xl={1}>
        <InputLabel className="RadioGroup-InputLabel" id={props.name} error={!!(meta.error && meta.touched)}>
          {t(props.label)}
        </InputLabel>
      </Grid>
      <Grid item xs={8} md={9} lg={10} xl={11}>
        <BaseRadioGroup row aria-label={props.name} id={props.name} {...field} {...props}>
          {props.children}
        </BaseRadioGroup>
      </Grid>
    </Grid>
  );
};

export default RadioGroup;
